import { Types } from "../../constants/index.js";
import SubField from "../builders/SubField.js";
export default SubField({
  objectType: Types.deviceGroup,
  baseAttrName: 'firmwareUpgradeOptions',
  baseAttrField: 'firmwareUpgradeOptions',
  field: 'percentDevicesToGetFirmwareApplication',
  creatable: true,
  editable: true,
  displayName: 'Firmware Upgrade Default Percent Devices To Get Upgrade',
  valueType: 'int'
});